import { IContentProvider } from '../types';

export default class YoutubeProvider implements IContentProvider  {
    pattern = /((?:http(?:s?):\/\/)?(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(?:&(?:amp;)?‌​[\w\?‌​=]*)?)($|(\s.+))/gi;

    isMatched(value: string): boolean {
        const re = new RegExp(this.pattern);
        return re.test(value);
    }

    getContent(resource: string): string {
        return (resource || '').replace(
            this.pattern,
            (_, link, videoId, text) => {
                if (link.indexOf('http') === -1) {
                    link = 'https://' + link;
                }
                const result = '<a href="' + link + '" target="_blank">' + link + '</a>' + text + '\n\n';
                return result + '<iframe class="inline_youtube_player" type="text/html" width="200" height="150" src="https://www.youtube.com/embed/' + videoId + '" frameborder="0" allowfullscreen/>\n\n';
            }
        );
    }
}
